import { isBlank } from '@ember/utils';
import isValidEmail from 'cio/utils/validators/email';

export default {
  email: {
    dependentKeys: ['currentPassword'],
    validator(value: string) {
      if (isBlank(value)) {
        return `Email should not be empty`;
      }

      if (!isValidEmail(value)) {
        return `Invalid email format`;
      }

      return true;
    },
  },

  currentPassword(value: string) {
    if (isBlank(value)) {
      return 'Your current password is required';
    }

    return true;
  },
};
